import type { ApiResult } from "./types";

const API_BASE = import.meta.env.VITE_API_BASE ?? "";

export async function api<T>(path: string, init?: RequestInit): Promise<ApiResult<T>> {
  const response = await fetch(`${API_BASE}${path}`, {
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(init?.headers ?? {}),
    },
    ...init,
  });

  const body = await response.json().catch(() => ({}));

  if (!response.ok) {
    return {
      ok: false,
      error: body?.error ?? "Request failed",
    };
  }

  return {
    ok: true,
    data: body as T,
  };
}

export async function postJson<T>(path: string, payload: unknown): Promise<ApiResult<T>> {
  return api<T>(path, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function putJson<T>(path: string, payload: unknown): Promise<ApiResult<T>> {
  return api<T>(path, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
}

export async function del<T>(path: string): Promise<ApiResult<T>> {
  return api<T>(path, {
    method: "DELETE",
  });
}
